<template>
  <StandardFlexBox
    direction="column"
    class="pl-1 pr-1"
    height="270px"
    >
    <StandardDataField
      placeholder="description"
      width="100%"
      flat="true"
      :resizable="true"
      :text_color="work_package.textcolor"
      :value="work_package.description"
      readonly="true"
    />
    <v-divider :color="work_package.textcolor" width="100%"/>
    <StandardFlexBox>
    <!-- attributes planned -->
    <StandardFlexBox
      class="pa-1"
      width="100%"
      direction="column"
      >
      {{$t('Project.Workpackage.Info.AttributesPlanned')}}
      <StandardFlexBox>
        <StandardDataField
        :value="work_package.time_effort_planned"
        icon="speed"
        width="28%"
        :text_color="work_package.textcolor"
        :type="'number'"
        readonly="true"
        />
        <div style="width: 8%; line-height: 33px; text-align: center;">/</div>
        <StandardDataField
          :value="work_package.manpower_planned"
          icon="accessibility"
          width="28%"
          :text_color="work_package.textcolor"
          :type="'number'"
          readonly="true"
          />
        <div style="width: 8%; line-height: 33px; text-align: center;">=</div>
        <StandardDataField
          :value="work_package.manpower_planned === 0 || isNaN(Math.round((work_package.time_effort_planned/work_package.manpower_planned)*100) / 100)?
                  '':Math.round((work_package.time_effort_planned/work_package.manpower_planned)*100) / 100"
          icon="timer"
          width="28%"
          :text_color="work_package.textcolor"
          :readonly="true"
          />
      </StandardFlexBox>
      <StandardFlexBox>
        <StandardDataField
          :value="work_package.quantity_value"
          icon="drag_indicator"
          width="33%"
          :text_color="work_package.textcolor"
          :type="'number'"
          readonly="true"
          />
        <StandardDataField
          :value="work_package.quantity_unit"
          icon="drag_indicator"
          width="33%"
          :text_color="work_package.textcolor"
          readonly="true"
          />
      </StandardFlexBox>
    </StandardFlexBox>
    </StandardFlexBox>
  </StandardFlexBox>
</template>
<script>
  import { WorkBenchWorkPackageInfoBoxMixin} from '@/mixins/WorkBenchWorkPackageInfoBox.mixin.js'
  export default {
    props: [],
    mixins: [
      WorkBenchWorkPackageInfoBoxMixin,
    ],
    data: () => ({
    }),
  }
</script>
<style>
  .class {

  }
</style>
